@if (uiConfiguration.showFileNumber) {
  <div class="flex-container">
    <span class="flex-item-3">{{ 'common.labels.fileNumber2' | transloco }}</span>
    <span class="flex-item-4" data-testid="discharge-details-file-number-text">{{ order.lien?.fileNumber }}</span>
  </div>
}
@if (!isDraft()) {
  <div class="flex-container">
    <span class="flex-item-3">{{ 'dischargeDetails.dischargeNumber' | transloco }}</span>
    <span class="flex-item-4" data-testid="discharge-details-number-text">{{ order.discharge?.dischargeNumber }}</span>
  </div>
}
@if (!isDraft()) {
  <div class="flex-container">
    <span class="flex-item-3">{{ 'dischargeDetails.dischargeDate' | transloco }}</span>
    <span class="flex-item-4" data-testid="discharge-details-date-text">{{ $safeNavigationMigration(order.discharge?.dischargeDate) | localizedDate: "yyyy-MM-dd" }}</span>
  </div>
}
@if (uiConfiguration.showDischargeType && order.discharge?.dischargeType) {
  <div class="flex-container">
    <span class="flex-item-3">{{ 'dischargeDetails.dischargeType' | transloco }}</span>
    <span class="flex-item-4" data-testid="discharge-details-type-text">{{ getDischargeType() }}</span>
  </div>
}
@if (uiConfiguration.showFormType && !isDraft()) {
  <div class="flex-container">
    <span class="flex-item-3">{{ 'dischargeDetails.qcFormType' | transloco }}</span>
    <span class="flex-item-4" data-testid="lien-details-authority-text">{{ order.lien?.qcFormTypeID }}</span>
  </div>
}
@if (uiConfiguration.showAuthorityText) {
  <div class="flex-container">
    <span class="flex-item-3">{{ 'dischargeDetails.authorityText' | transloco }}</span>
    <span class="flex-item-4" data-testid="lien-details-authority-text">{{ order.lien?.authorityText }}</span>
  </div>
}